<app-module-header [title]="organization.organizationName + ' - ' + ('CAMERAS.TITLE' | transloco)"
  [icon]="'camera'"></app-module-header>

@if (loading) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-tab-group dynamicHeight (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Live">
    <div class="dashboard-container">
      @if (cameras?.length > 0) {
      <div class="camera-grid">
        @for (cam of cameras; track cam) {
        <div class="camera-card">
          <div class="header">
            <div class="d-flex align-items-center w-100">
              <mat-icon>meeting_room</mat-icon>
              <span class="ms-2">{{ cam.description }}</span>
            </div>
          </div>
          <div class="gate-actions d-flex align-items-center justify-content-end flex-wrap w-100">
            <div class="d-flex align-items-center gap-1 w-100">
              <button mat-icon-button (click)="startCameraStream(cam.sensorId)">
                <mat-icon>refresh</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="stopStream(cam.sensorId)">
                <mat-icon>stop</mat-icon>
              </button>
              <button mat-icon-button class="fullscreen-btn" (click)="enlargeVideo(videoPlayer)">
                <mat-icon>fullscreen</mat-icon>
              </button>
            </div>
          </div>
          <div class="video-container">
            <video #videoPlayer [id]="cam.sensorId" class="video-player" width="100%" height="auto"
              poster="/assets/img/placeholder.jpg" disablePictureInPicture controlsList="nopictureinpicture">
              {{ 'CAMERAS.VIDEO_NOT_SUPPORTED' | transloco }}
            </video>
            @if (!cameraStates[cam.sensorId]) {
            <div (click)="startCameraStream(cam.sensorId)" class="video-placeholder">
              <div class="placeholder-content">
                <mat-icon class="placeholder-icon">videocam_off</mat-icon>
                <p>{{ 'CAMERAS.CLICK_TO_START' | transloco }}</p>
              </div>
            </div>
            }
          </div>
          <div class="display-container">
            @for (display of cam.displays; track display) {
            <div class="d-flex flex-row align-items-center justify-content-between">
              @if (myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId),
              'ParkingOperator', $safeNavigationMigration(organization?.organizationParentId)) ||
              myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId),
              'ParkingAdministrator', $safeNavigationMigration(organization?.organizationParentId))) {
              <a [href]="parkingDisplay + '?id='+display.id" target="_blank">
                <mat-icon>connected_tv</mat-icon>
                <span>{{ display.name ? display.name : display.id }}</span>
              </a>
              <button mat-button mat-stroked-button color="primary"
                (click)="openDisplayTests(cam.id, display)">Test</button>

              } @else {

              <a class="non-clickable">
                <mat-icon>connected_tv</mat-icon>
                <span>{{ display.name ? display.name : display.id }}</span>
              </a>

              }

            </div>
            }
          </div>
        </div>
        }
      </div>

      } @else {

      <div class="empty-state">
        <mat-icon class="empty-icon">garage</mat-icon>
        <p class="empty-message">{{ 'CAMERAS.NO_GATES_CONFIGURED' | transloco }}</p>
      </div>

      }


    </div>
  </mat-tab>

  <mat-tab label="Monitor">
    <div class="cctv-container" #cctvContainer>
      <div class="cctv-header">
        <div class="d-flex align-items-center gap-2">
          <button mat-raised-button color="primary" (click)="startAllStreams('-cctv')">
            <mat-icon>play_arrow</mat-icon>{{ 'CAMERAS.START_ALL' | transloco }}
          </button>
          <button mat-raised-button color="warn" (click)="stopAllStreams('-cctv')">
            <mat-icon>stop</mat-icon> {{ 'CAMERAS.STOP_ALL' | transloco }}
          </button>
          <button mat-raised-button (click)="isCctvFullscreen ? exitFullscreen() : enlargeVideo(cctvContainer)">
            <mat-icon>{{ isCctvFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
            {{ isCctvFullscreen ? ('CAMERAS.EXIT_FULL_SCREEN' | transloco) : ('CAMERAS.FULL_SCREEN' | transloco) }}
          </button>
        </div>
      </div>

      @if (groupedCameras?.length > 0) {
      <div class="cctv-grid" [style.--cctv-cols]="cctvColumns">
        @for (group of groupedCameras; track group; let i = $index) {
        @for (cam of group.cameras; track cam) {
        <div class="cctv-group">
          <div class="cctv-cam-card">
            @if(organization?.organizationId == 'f812a7d8-e4a6-48e2-9ed0-827317772863'){
            <div class="cctv-overlay-title" [ngStyle]="getOverlayTitleStyle(i)">
              {{ group.organizationName }} - {{ cam.description }}
            </div>
            }@else{
            <div class="cctv-overlay-title" [ngStyle]="getOverlayTitleStyle(i)">
              {{ cam.description }}
            </div>
            }
            <div class="cctv-video-container">
              <video #cctvVideoPlayer [id]="cam.sensorId + '-cctv'" class="cctv-video-player"
                poster="/assets/img/placeholder.jpg" disablePictureInPicture controlsList="nopictureinpicture">
                {{ 'CAMERAS.VIDEO_NOT_SUPPORTED' | transloco }}
              </video>
              @if (!cameraStates[cam.sensorId + '-cctv']) {
              <div (click)="startCameraStream(cam.sensorId, '-cctv')" class="cctv-placeholder">
                <mat-icon class="placeholder-icon">videocam_off</mat-icon>
                <span>{{ 'CAMERAS.OFFLINE_CLICK_TO_STREAM' | transloco }}</span>
              </div>
              }
            </div>
            <div class="cctv-controls-overlay">
              <button mat-icon-button (click)="startCameraStream(cam.sensorId, '-cctv')" class="cctv-ctrl-btn">
                <mat-icon>refresh</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="stopStream(cam.sensorId, '-cctv')">
                <mat-icon>stop</mat-icon>
              </button>
              <button mat-icon-button (click)="enlargeVideo(cctvVideoPlayer)" class="cctv-ctrl-btn">
                <mat-icon>fullscreen</mat-icon>
              </button>
            </div>
          </div>
        </div>
        }
        }
      </div>
      } @else {
      <div class="empty-state">
        <mat-icon class="empty-icon">garage</mat-icon>
        <p class="empty-message">{{ 'CAMERAS.NO_GATES_CONFIGURED' | transloco }}</p>
      </div>
      }

    </div>
  </mat-tab>

  <mat-tab label="Archive">
    <div class="dashboard-container">
      <div class="archive-card">
        <div class="archive-controls">
          <select class="archive-select" [(ngModel)]="archiveCamera">
            @for (cam of surCamerasList; track cam) {
            <option [value]="cam">{{ getCameraDescription(cam) }}</option>
            }
          </select>

          <input type="date" class="archive-select" [min]="archiveMinDate" [max]="archiveMaxDate"
            [(ngModel)]="archiveDate" (change)="onDateChange()" />

          <select class="archive-select" [(ngModel)]="archiveHour" (change)="onHourChange()">
            @for (h of hours; track h) {
            <option [value]="h">{{ h }}</option>
            }
          </select>

          <select class="archive-select" [(ngModel)]="archiveMinute">
            @for (m of getAvailableMinutes(); track m) {
            <option [value]="m">{{ m }}</option>
            }
          </select>

          <button mat-raised-button color="primary" (click)="loadArchiveStream()"
            [disabled]="!archiveCamera || !archiveDate">
            <mat-icon>play_arrow</mat-icon>{{ 'CAMERAS.LOAD' | transloco }}
          </button>

          @if (cameraStates['archive-player']) {
          <div class="archive-speed-controls">
            @for (speed of archiveSpeeds; track speed) {
            <button mat-stroked-button [color]="archivePlaybackRate === speed ? 'primary' : ''"
              (click)="setArchiveSpeed(speed)">
              {{ speed }}x
            </button>
            }
          </div>
          }
        </div>

        <div class="video-container">
          <video id="archive-player" class="video-player" controls width="100%" height="auto"
            poster="/assets/img/placeholder.jpg" disablePictureInPicture controlsList="nopictureinpicture">
            {{ 'CAMERAS.VIDEO_NOT_SUPPORTED' | transloco }}
          </video>
          @if (!cameraStates['archive-player']) {
          <div class="video-placeholder no-click">
            <div class="placeholder-content">
              <mat-icon class="placeholder-icon">history</mat-icon>
              <p>{{ 'CAMERAS.SELECT_CAMERA_DATE_TIME' | transloco }}</p>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </mat-tab>

</mat-tab-group>